function CreatePassword () {
  var self = this;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

  }
  
  this.validateApplication = function () {

    jQuery.validator.addMethod("pwcheck", function(value) {
      var specials = /[^A-Za-z 0-9]/g;
      return /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g.test(value) && /[a-z]/.test(value) && /\d/.test(value) && /[A-Z]/.test(value);
    });

    var formHasBeenSubmitted = false;

    $("#createPassword").validate({

      ignore: ":hidden",
      onkeyup: false,

      highlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          $(element)
            .closest('.donation-group')
            .addClass('invalid');
        } else {
          $(element)
            .closest('.text-input')
            .addClass('invalid');
        }
      },

      unhighlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          var group = $(element).closest('.donation-group');

          // only mark valid if one is checked
          if ($('input[name="' + element.name + '"]:checked').length) {
            group.removeClass('invalid');
          }
        } else {
          $(element)
            .closest('.text-input')
            .removeClass('invalid');
        }
      },

      /*  ios8 & above only scroll back to the focus of the first error. If you hit submit again & there is another error
          it will not scroll. This confuses the user as they do not think there is another error message. This code fixes that. */
      invalidHandler: function(e, validator) {
        formHasBeenSubmitted = true;

        if (window.navigator.userAgent.match(/iphone/i)) {
          window.setTimeout(function() {

            var el = $(validator.errorList[0].element);

            var target = el.attr("type") === "radio"
              ? el.closest('.donation-group')
              : el;

            $("html,body").animate({
              scrollTop: target.offset().top
            });

          }, 0);
        }
      },

      errorPlacement: function(error, element) {
        error.addClass('input-error caption');

        if (element.attr("type") === "radio") {
          error.insertAfter(element.closest('.donation-group'));
        } else {
          var wrapper = element.closest('.text-input-wrapper');
          var description = wrapper.find('.input-description');

          if (description.length) {
            error.insertBefore(description);
          } else {
            wrapper.append(error);
          }
        }
      },

      rules: {
        newpassword: {
          minlength: 8,
          required: true,
          pwcheck: true
        },
        confirmpassword: {
          equalTo: "#newpassword"
        }
      },

      messages: {
        newpassword: {
          required: 'Enter your password',
          pwcheck: 'Passwords must be a minimum of 8 characters, contain upper and lower case letters, a symbol and at least one number.',
          minlength: 'Please enter at least 8 characters.'
        },
        confirmpassword: {
          required: 'Enter the confirmed password',
          equalTo: 'The password and confirm passwords need to match'
        }
      },

      submitHandler: function(form) {

        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#createPassword').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            jQuery('#createPassword').prepend('<input type="hidden" name="addedPassword" value="1">');
            form.submit();
          });
        });

      }

    });

  }

  this.checkPasswordStrength = function(password) {
    return {
      length: password.length >= 8,
      lower: /[a-z]/.test(password),
      upper: /[A-Z]/.test(password),
      number: /\d/.test(password),
      symbol: /[^A-Za-z0-9]/.test(password)
    };
  };

  this.bindEvents = function () {

    self.togglePasswordVisibility("#show_hide_password");
    self.togglePasswordVisibility("#show_hide_password_confirm");

    $("#newpassword, #confirmpassword").on("input", function () {
      self.renderPasswordUI();
    });

  }

  this.togglePasswordVisibility = function (selector) {

    $(selector + " .toggle-password").on("click", function (event) {
      event.preventDefault();

      const wrapper = $(this).closest(".password-field");
      const input = wrapper.find("input");
      const openIcon = wrapper.find(".icon-eye-open");
      const closedIcon = wrapper.find(".icon-eye-closed");

      const isHidden = input.attr("type") === "password";

      if (isHidden) {
        input.attr("type", "text");
        openIcon.show();
        closedIcon.hide();
      } else {
        input.attr("type", "password");
        openIcon.hide();
        closedIcon.show();
      }
    });
  };

  this.getPasswordState = function () {
    const password = $("#newpassword").val();
    const confirm = $("#confirmpassword").val();

    const checks = self.checkPasswordStrength(password);

    const allValid = Object.values(checks).every(Boolean);
    const matches = password && password === confirm;

    return {
      checks,
      score: Object.values(checks).filter(Boolean).length,
      allValid,
      matches,
      isValid: allValid && matches
    };
  };

  this.renderPasswordUI = function () {
    const state = self.getPasswordState();

    // Update checklist
    Object.keys(state.checks).forEach(key => {
      $(`[data-check="${key}"]`)
        .toggleClass("valid", state.checks[key]);
    });

    // Update bar
    const percentage = (state.score / 5) * 100;

    $("#strengthFill")
      .css("width", percentage + "%")
      .attr("data-strength", state.score);

    const confirm = $("#confirmpassword").val();

    if (confirm.length > 0) {
      $("#matchedPasswords")
        .text(state.matches ? "Passwords match" : "Passwords do not match")
        .toggleClass("passwordsMatched", state.matches)
        .toggleClass("passwordsDidNotMatch", !state.matches);
    } else {
      $("#matchedPasswords")
        .text("")
        .removeClass("passwordsMatched passwordsDidNotMatch");
    }

    $("#setPassButton").prop("disabled", !state.isValid);
  };

}

module.exports = CreatePassword;
